/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';
import { FontWeight, FiraSansBold } from 'components/Text';
import {mediaHelper} from "../../utils/src";
import { Breakpoints } from 'constants/Breakpoints';
import { Field } from 'formik';

export const Content = styled.div`
  background: ${Colors.WHITE};
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  margin-bottom: 50px;
  border: 1px solid ${Colors.BLUE};
  background: ${Colors.WHITE};
  border-radius: 0px 0px 10px 10px;
  box-shadow: 0px 17px 17px 6px ${Colors.GRAY[4]};
  padding: 5px;
  
  ${mediaHelper.sm`
    padding: 10px;
    border-radius: 0px 0px 15px 15px;
  `}
  
  ${mediaHelper.md`
    border-radius: 0px 0px 20px 20px;
  `}
`;

export const Heading = styled.div`
  background: ${Colors.BLUE};
  display:flex;
  align-items:center;
  justify-content: space-between;
  color: ${Colors.WHITE};
  padding: 5px 10px;
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 14px;
  border-radius: 10px 10px 0px 0px;
  margin-top: 20px;
  position: relative;

  ${mediaHelper.sm`
    padding: 10px 15px;
    font-size: 18px;
    border-radius: 15px 15px 0px 0px;
  `}
  
  ${mediaHelper.md`
    border-radius: 20px 20px 0px 0px;
  `}
`;

export const ColIcon = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px;
  padding: 5px;
  justify-content: flex-start;
  align-items: center;
`

export const RowIcon = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FilterContainer = styled.div`
  &.filter-close {
    display: none;
  }

  &.filter-open {
    position: absolute;
    right: 0;
    top: 60px;
    background-color: ${Colors.WHITE};
    z-index: 10;
    padding: 15px;
    width: 350px;
    box-shadow: -5px 5px 20px -10px black;

    > div > div {
      background-color: ${Colors.WHITE};  
    }
  }

  @media (max-width: ${Breakpoints.md}) {
    &.filter-close {
      display: none;
    }

    &.filter-open {
      position: fixed;
      overflow-x: scroll;
      top: 0;
      height: 100%;
      left: 0;
      width: 100%;
      background-color: ${Colors.WHITE};
      z-index: 2000;
      padding: 10px;

      > div > div {
        background-color: ${Colors.WHITE};  
      }
    }
    
    .icon-close {
      position: absolute;
      top: 0;
      right: 0;
      margin: 10px 15px;
      font-size: 30px;
    }
  }
`;

export const FilterSearchContainer = styled.div`
  border-radius: 20px 20px 0 0;
  width: 100%;
  margin-bottom: 10px;
`;

export const MobileLabel = styled.span`
  font-weight: ${FiraSansBold};
  text-transform: uppercase;
  font-size: 16px;
  color: ${Colors.GREEN};
`;

export const RowFilter = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  padding: 5px;
`;

export const CheckBoxColumn = styled.div`
  width: 20%;
`;

export const FilterColumn = styled.div`
  width: 100%;
`;

export const FieldGrid = styled(Field)`
  border-radius: 4px;
  padding-left: 5px;
  vertical-align: middle;
  
  & div {
    min-height: 0 !important;
    margin-bottom: 0 !important;
  }
`